import { render, staticRenderFns } from "./Honeycomb.vue?vue&type=template&id=5afa528b&scoped=true"
import script from "./Honeycomb.vue?vue&type=script&lang=js"
export * from "./Honeycomb.vue?vue&type=script&lang=js"
import style0 from "./Honeycomb.vue?vue&type=style&index=0&id=5afa528b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa528b",
  null
  
)

export default component.exports